export const normalizePhotoUrl = (url?: string | null): string | null | undefined => {
  if (!url) return url;
  if (url.startsWith('product-photos/https://')) {
    return url.replace(/^product-photos\//, '');
  }
  return url;
};
